class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');
    this.predictiveSearchResultsViewAll = document.querySelector('#search-view-all');
    this.predictiveSearchResultsSuggested = document.querySelector('#predictive-search--suggested');
    this.predictiverSearchResultsCollections = document.querySelector('#predictive-search--collections');
    this.predictiveSearchResultsRelatedContent = document.querySelector('#predictive-search--related');
  
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      document.body.classList.remove('search-text-entered');
      return;
    }
    else {
      document.body.classList.add('search-text-entered');
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search&resources[options][fields]=body,product_type,tag,title,variants.barcode,variants.sku,variants.title,vendor&resources[limit]=6&resources[limit_scope]=each`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const link = `/search?q=${searchTerm}`;
        this.predictiveSearchResultsViewAll.setAttribute("href", link);


        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

        async function generateProductResults() {
          return new Promise((resolve) => {
            let searchResultsProducts = new DOMParser().parseFromString(resultsMarkup, 'text/html').querySelector('.js-search-results-products').innerHTML;
            resolve(searchResultsProducts);
          });
        }

        generateProductResults().then((searchResultsProducts) => {  
          this.predictiveSearchResults.innerHTML = searchResultsProducts;
          const event = new CustomEvent('initPredictiveSearchSwiper', {
            detail: {
              container: this.predictiveSearchResults
            }
          });
          document.dispatchEvent(event);
        });
      
        if (this.predictiveSearchResultsSuggested) {
          async function generateSuggestedResults() {
            return new Promise((resolve) => {
              let searchResultsSuggested = new DOMParser().parseFromString(resultsMarkup, 'text/html').querySelector('.js-search-results-suggested').innerHTML;
              resolve(searchResultsSuggested);
            });
          }
          
          generateSuggestedResults().then((searchResultsSuggested) => {
            this.predictiveSearchResultsSuggested.innerHTML = searchResultsSuggested;
          });       
        }

        if (this.predictiverSearchResultsCollections) {
          async function generateCollectionResults() {
            return new Promise((resolve) => {
              let searchResultsCollections = new DOMParser().parseFromString(resultsMarkup, 'text/html').querySelector('.js-search-results-collections').innerHTML;
              resolve(searchResultsCollections);
            });
          }
          generateCollectionResults().then((searchResultsCollections) => {
            this.predictiverSearchResultsCollections.innerHTML = searchResultsCollections;
          });
        }

        if (this.predictiveSearchResultsRelatedContent) {
          async function generateRelatedContentResults() {
            return new Promise((resolve) => {
              let searchResultsRelatedContent = new DOMParser().parseFromString(resultsMarkup, 'text/html').querySelector('.js-search-results-related-content').innerHTML;
              resolve(searchResultsRelatedContent);
            });
          }
          generateRelatedContentResults().then((searchResultsRelatedContent) => {
            this.predictiveSearchResultsRelatedContent.innerHTML = searchResultsRelatedContent;
          });
        }

        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
